import React from "react";
import { Cctv } from "lucide-react";

const cone = ({ x, y, dir, spread, len }) => {
  const r = (d) => (d * Math.PI) / 180;
  const a = r(dir - spread / 2), b = r(dir + spread / 2);
  return `M${x},${y} L${x + len * Math.cos(a)},${y + len * Math.sin(a)} A${len},${len} 0 0 1 ${x + len * Math.cos(b)},${y + len * Math.sin(b)} Z`;
};

export const CameraCones = ({ cams, size, reduce }) => (
  <>
    <svg className="pointer-events-none absolute inset-0 h-full w-full" viewBox={`0 0 ${size[0]} ${size[1]}`} preserveAspectRatio="none" aria-hidden="true" data-testid="villa-cams">
      <defs>
        {cams.map((c) => (
          <radialGradient key={c.id} id={`cam-g-${c.id}`} gradientUnits="userSpaceOnUse" cx={c.x} cy={c.y} r={c.len}>
            <stop offset="0%" stopColor="#FF7A00" stopOpacity="0.75" />
            <stop offset="65%" stopColor="#FF7A00" stopOpacity="0.26" />
            <stop offset="100%" stopColor="#FF7A00" stopOpacity="0" />
          </radialGradient>
        ))}
      </defs>
      {cams.map((c, i) => (
        <g key={c.id} className={reduce ? "" : "pt-sweep"} style={{ transformOrigin: `${c.x}px ${c.y}px`, animationDelay: `${i * 1.3}s` }}>
          <path d={cone(c)} fill={`url(#cam-g-${c.id})`} />
        </g>
      ))}
    </svg>
    {cams.map((c) => (
      <span key={c.id} className="pointer-events-none absolute z-10 -ml-2.5 -mt-2.5 grid h-5 w-5 place-items-center rounded-full border-2 border-white bg-[#FF7A00] shadow-[0_4px_14px_rgba(255,122,0,0.5)] sm:-ml-3.5 sm:-mt-3.5 sm:h-7 sm:w-7" style={{ left: `${(c.x / size[0]) * 100}%`, top: `${(c.y / size[1]) * 100}%` }} data-testid={`villa-cam-${c.id}`}>
        <Cctv size={13} color="#fff" strokeWidth={2.4} />
        {!reduce && <span className="pt-rec absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white" />}
      </span>
    ))}
  </>
);
